import MetadataDocumentFieldDetailsDrawer from '@modules/MetaDocumentBuilder/materials/drawers/MetadataDocumentFieldDetailsDrawer.vue';

export default {
	MetadataDocumentFieldDetailsDrawer,
};
